module.exports = __webpack_public_path__ + "img/logo_w.22308d14.png";